import { create } from "zustand";
import { persist } from "zustand/middleware";

type MenuStore = {
  sideMenuOpen: boolean;
  sideMenuHidden: boolean;
  setSideMenuOpen: (value: boolean) => void;
  setSideMenuHidden: (value: boolean) => void;
};

export const useMenuStore = create<MenuStore>()(
  persist(
    (set) => ({
      sideMenuOpen: true,
      sideMenuHidden: false,
      setSideMenuOpen: (value) => set({ sideMenuOpen: value }),
      setSideMenuHidden: (value) => set({ sideMenuHidden: value }),
    }),
    {
      // Must stay in sync with RIMS_LOCAL_STG_CONSTANTS.AC_MENU_STORE, which is
      // preserved during logout so menu preferences survive logout/login.
      name: "ac-menu-store",
      partialize: (state) => ({
        sideMenuOpen: state.sideMenuOpen,
        sideMenuHidden: state.sideMenuHidden,
      }),
    }
  )
);
